import {KIDS_V2_SSO_TOKEN} from "@/services/ConstantService";

export const KidsV2Service = {
  async generateSSOToken(){
    const { default : axios } = await import('axios');
    return axios.get(KIDS_V2_SSO_TOKEN);
  }
}
